<template>
  <div class="card-body maxheight">
    <div class="row justify-content-center">
      <div class="col-8">
        <div class="row lead ml-2 mt-4">
          <span v-if="usesQ4">{{
              buildTitle(data.title, user)
          }}</span><span v-else>
            {{ data.title }}
          </span>
        </div>
        <div class="row my-4 ml-4 justify-content-center">
          <div class="col">
          <form>
            <div v-for="(response, index) in responses" v-bind:key="index" class="form-check mt-1">
            
              <input v-model="answer" @input="onValueChange" class="form-check-input" type="radio" :value="index" :name="index" />
              <label @click="onClick(index)" class="form-check-label" v-bind:for="index">
                {{ response }}
              </label>
              <input v-if="uniqueQuestion == index" v-show="uniqueQuestion == answer" type="uniqueInput"
                  v-model="uniqueInput" @input="onInputChange" class="form-control" />
                  
            </div>
          </form>
          <p  v-show="textError===true" v-if="uniqueQuestion == answer" class="text-danger small">Please enter a response</p>
          <p v-if="inputError===true" class="text-danger small">Please select an answer </p>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="card-footer border border-rounded">
    <div class="row justify-content-center">
      <div @click="previous()" class="btn btn-small nsc-cta  mx-4 my-2">
      Previous
      </div>
      <div @click="validateAnswer();" class="btn btn-small nsc-cta blue mx-4 my-2">
        Next
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Radio",
  props: ["data","prevQ", "nextQ", "user", "answers", "uniqueI"],
  emits: ["nextQuestion", "previousQuestion","uniqueAnswer"],
  data() {
    return {
      responses: this.data.responses,
      uniqueQuestion: this.findUniqueInput(this.data.responses),
      uniqueInput: this.uniqueI,
      answer: this.answers,
      inputError: null,
      textError:null,
      next: this.nextQ,
      usesQ4: this.data.usesQ4 ? true : false,
    };
  },
  methods: {
    findUniqueInput(arr) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].includes("describe below")) {
          return i;
        }
      }
      return -1;
    },
    previous() {
      this.$emit('previousQuestion', this.prevQ, this.answer)
    },
    onClick(val) {
      
      this.answer = val
    },
    validateAnswer() {
      if (this.answer == this.uniqueQuestion && this.uniqueInput) {
        // console.log(this.uniqueInput)
        this.next = this.questionPiping(this.data, this.answer)
        this.$emit('uniqueAnswer', this.data.ID, this.uniqueInput)
        this.$emit('nextQuestion', this.next, this.answer)
      } else if (this.answer == undefined ){
        this.inputError = true
      } else if (this.answer === this.uniqueQuestion && (!this.uniqueInput)) {
        // console.log("no answer yet")
        
        this.textError = true

      } else {
        // console.log(this.answer)
        this.next = this.questionPiping(this.data, this.answer)
        this.$emit('nextQuestion', this.next, this.answer)
      }
    },
    onInputChange(){
      this.textError = false
      // console.log('here')
    },
    onValueChange(){
      this.inputError = false
      // console.log('there')
    },
    questionPiping(currentQ, answer) {

      if (currentQ.ID == 6) {
        if (answer == 4) {
          return 8
        }
        if (answer == 10) {
          return 7
        }
        if (answer == 18) {
          return 9
        }
        return 10
      }
      if (currentQ.ID == 7 || currentQ.ID == 8) {
        return 10
      }

      return this.next
    },
    buildTitle(arr, user) {
      return `${arr[0]} ${user.company} ${user.subsector} ${arr[1]}`;
    },
  },
  mounted(){
    

  }

};
</script>